package com.yogaaicoach.pages.workout

internal fun exerciseImageUrl(exerciseName: String): String? {
    val filename = exerciseImageFilenames[exerciseName] ?: return null
    return "exercise-images/$filename.png"
}

private val exerciseImageFilenames = mapOf(
    "Bicycle Crunches" to "bicycle_crunches",
    "Big Toe Pose" to "big_toe_pose",
    "Bird Dog Flow" to "bird_dog_flow",
    "Boat Pose" to "boat_pose",
    "Bound Angle Pose" to "bound_angle_pose",
    "Bow Pose" to "bow_pose",
    "Bridge Pose" to "bridge_pose",
    "Camel Pose" to "camel_pose",
    "Cat-Cow Pose" to "cat-cow_pose",
    "Chair Pose" to "chair_pose",
    "Child’s Pose" to "childs_pose",
    "Cobra Pose" to "cobra_pose",
    "Cow Face Pose" to "cow_face_pose",
    "Dancing Warrior Sequence" to "dancing_warrior_sequence",
    "Dolphin Pose" to "dolphin_pose",
    "Downward Dog to Warrior I Transition" to "downward_dog_to_warrior_i_transition",
    "Downward-Facing Dog" to "downward-facing_dog",
    "Eagle Pose" to "eagle_pose",
    "Extended Hand to Big Toe Pose" to "extended_hand-to-big-toe_pose",
    "Extended Hand to Big Toe Pose Side" to "extended_hand-to-big-toe_pose_side",
    "Extended Puppy Pose" to "extended_puppy_pose",
    "Extended Side Angle" to "extended_side_angle",
    "Extended Triangle Pose" to "extended_triangle_pose",
    "Fish Pose" to "matsyasana",
    "Flamingo Pose" to "flamingo_pose",
    "Flowing Bridge" to "flowing_bridge",
    "Forearm Plank" to "forearm_plank",
    "Forward Fold" to "forward_fold",
    "Frog Pose" to "frog_pose",
    "Garland Pose" to "garland_pose",
    "Goddess Pose" to "goddess_pose",
    "Half Bound Lotus Forward Bend" to "half_bound_lotus_forward_bend",
    "Half Bound Lotus Standing Forward Bend" to "half_bound_lotus_standing_forward_bend",
    "Half Chair Pose with Heel Lift" to "half_chair_pose_with_heel_lift",
    "Half Moon Pose" to "half_moon_pose",
    "Half Pigeon Pose" to "pigeon_pose",
    "Hand Under Foot Pose" to "hand_under_foot_pose",
    "Happy Baby Pose" to "happy_baby_pose",
    "Headstand" to "headstand",
    "Head-to-Knee" to "head-to-knee_pose",
    "Hero Pose" to "hero_pose",
    "High Lunge Pose" to "high_lunge_pose",
    "High Lunge Pose with Heel Lift" to "high_lunge_pose_with_heel_lift",
    "Intense Side Stretch" to "intense_side_stretch",
    "Knees-to-Chest Pose" to "knees-to-chest_pose",
    "Lizard Pose" to "lizard_pose",
    "Locust Pose" to "locust_pose",
    "Low Boat Pose" to "low_boat_pose",
    "Low Lunge Pose" to "low_lunge",
    "Marichi's Pose A" to "marichis_pose_a",
    "Moon Salutation" to "moon_salutation",
    "Mountain Climbers" to "mountain_climbers",
    "Mountain Pose to Chair Pose Flow" to "mountain_pose_to_chair_pose_flow",
    "Namaste" to "namaste",
    "Plank Pose" to "plank_pose",
    "Plank to Chaturanga" to "plank_to_chaturanga",
    "Plank to Dolphin Pose Flow" to "plank_to_dolphin_pose",
    "Plank to Downward Dog" to "plank_to_downward_dog",
    "Plow Pose" to "halasana",
    "Reclined Bound Angle Pose" to "reclined_bound_angle_pose",
    "Reclined Pigeon Pose" to "reclined_pigeon_pose",
    "Reclining Angle Pose" to "supta_konasana",
    "Reclining Hand-to-Big-Toe Pose" to "supta_padangusthasana",
    "Reverse Tabletop Pose" to "reverse_tabletop_pose",
    "Reverse Warrior" to "reverse_warrior",
    "Revolved Chair Pose" to "revolved_chair_pose",
    "Revolved Half Moon Pose" to "revolved_half_moon_pose",
    "Revolved High Lunge Pose" to "revolved_high_lunge_pose",
    "Revolved Side Angle" to "revolved_side_angle_pose",
    "Revolved Triangle Pose" to "revolved_triangle_pose",
    "Samasthiti" to "mountain_pose",
    "Savasana" to "savasana_namaste",
    "Scissor Kicks" to "scissor_kicks",
    "Seated Breath Awareness" to "seated_breath_awareness",
    "Seated Forward Bend" to "seated_forward_bend",
    "Seated Twist" to "seated_twist",
    "Shoulder Stand" to "sarvangasana",
    "Side Plank" to "side_plank",
    "Side Plank to Wild Thing Flow" to "side_plank_to_wild_thing_flow",
    "Single-Leg Mountain Pose" to "single_leg_mountain_pose",
    "Sphinx Pose" to "sphinx_pose",
    "Staff Pose" to "dandasana",
    "Standing Splits" to "standing_splits",
    "Sun Salutation A" to "sun_salutation_a",
    "Sun Salutation B" to "sun_salutation_b",
    "Superman Pose" to "superman_pose",
    "Supine Twist" to "supine_twist",
    "Thread the Needle Pose" to "thread_the_needle_pose",
    "Three-Legged Downward Dog to Plank Flow" to "three_legged_downward_dog_to_plank_flow",
    "Three-Limbed Forward Bend" to "three_limbed_forward_bend",
    "Tree Pose" to "tree_pose",
    "Triangle Pose" to "triangle_pose",
    "Upward Bow Pose" to "urdhva_dhanurasana",
    "Upward Plank Pose" to "upward_plank_pose",
    "Upward-Facing Dog" to "upward_facing_dog",
    "Warrior Flow" to "warrior_flow",
    "Warrior I" to "warrior_I",
    "Warrior II" to "warrior_II",
    "Warrior III" to "warrior_III",
    "Wide-Angle Seated Forward Bend" to "wide-angle_seated_forward_bend",
    "Wide-Legged Forward Bend A,B,C,D" to "prasarita_padottanasana_a_b_c_d",
    "Wild Thing" to "wild_thing",
)
